import { ReactNode } from 'react';

import { Loader } from '@any-ui-react/core';
import classNames from 'classnames';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxLoadingProps {
  className?: string;
  children?: ReactNode;
}

export const ComboboxLoading = ({ className, children }: ComboboxLoadingProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <div className={classNames(styles.loading(), contextClassNames?.loading, className)}>
      {children || <Loader size="xs" />}
    </div>
  );
};
